import { Injectable } from '@angular/core';
import { BaseCoreState, baseDocumentSelectors } from '../../_store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DocumentListItemResponse } from '../../../api';
import { filter, map, take, switchMap } from 'rxjs/operators';
import { DocumentCategoryType } from '../../modules/documents/_types/base-document-category.type';

@Injectable()
export class BaseDocumentsService {
  constructor(private store: Store<BaseCoreState>) {}

  getDocumentsWithCategories(categoryType: DocumentCategoryType) {
    return this.store.select(baseDocumentSelectors.getDocuments).pipe(
      filter((documentsState) => !!documentsState.ok),
      map((documentsRes) => documentsRes?.data ?? []),
      switchMap((documents) =>
        this.store.select(baseDocumentSelectors.getDocumentCategories).pipe(
          filter((categoriesState) => !!categoriesState.ok),
          take(1),
          map((categoriesRes) => categoriesRes?.data?.[categoryType] ?? {}),
          map((categoriesRaw) => {
            const categories = this.mapCategories(categoriesRaw);
            const docsWithLabels = this.attachLabelsToDocuments(documents, categories);

            return {
              categories,
              documents: docsWithLabels,
            };
          })
        )
      )
    );
  }

  getDocumentCategories(categoryType: DocumentCategoryType): Observable<{ value: number; label: string }[]> {
    return this.store.select(baseDocumentSelectors.getDocumentCategories).pipe(
      filter((state) => !!state.ok),
      map((categories) => categories.data?.[categoryType] as Record<number, string>),
      map((categories) => this.mapCategories(categories))
    );
  }

  mapCategories(raw: Record<number, string>): { value: number; label: string }[] {
    return Object.entries(raw).map(([key, label]) => ({
      value: +key,
      label: label as string,
    }));
  }

  attachLabelsToDocuments(
    documents: DocumentListItemResponse[],
    categories: { value: number; label: string }[]
  ): { document: DocumentListItemResponse; categoryLabel?: string }[] {
    return documents.map((document) => ({
      document,
      categoryLabel: categories.find((category) => category.value === document.category)?.label,
    }));
  }
}
